@import 'styles/mixins';
@import 'styles/variables';

.quickReactions {
  @include shadow-3;
  display: flex;
  border-radius: 4px;
  background: var(--neutral-0);
  padding: 4px;
  z-index: 1;
}

.quickReaction {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
}

.popoverOverride {
  padding: 0;
}
